export interface AppInfo {
  build: string;
  version: string;
  package: string;
}

export interface AppRegisterLead {
  phone: string;
  email: string;
  origin: string;
}

export enum AppPeriod {
  Day = 'day',
  Week = 'week',
  Month = 'month',
  Year = 'year',
  All = 'all',
}

export enum AppPlatform {
  Android = 'android',
  Ios = 'ios',
  Web = 'web',
  Undefined = 'undefined',
}

export enum BrandColorsEnum {
  INDEPENDENCE = 'independence',
  NEUTRAL = 'neutral',
  OPPORTUNITY = 'opportunity',
  BRAND = 'brand',
}
